import api from "api/api";

export const getCalculateCoefXQuery = async ({ amount }) =>
  await api.get(`settings/coefx/calc?amount=${amount}`);
